import { AppRoutes } from './router';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import ExitIntentPopup from './components/feature/ExitIntentPopup';
import ScrollToTop from './components/feature/ScrollToTop';
import BackToTop from './components/feature/BackToTop';
import RouteProgressBar from './components/feature/RouteProgressBar';
import WhatsAppButton from './components/feature/WhatsAppButton';
import CookieConsent from './components/feature/CookieConsent';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <RouteProgressBar />
        <ScrollToTop />
        <AppRoutes />
        <ExitIntentPopup />
        <BackToTop />
        <WhatsAppButton />
        <CookieConsent />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
